import { MechanicSchema } from './mechanic';
import z from 'zod';

/**
 * Represents a level in the game, which consists of multiple mechanics.
 */
export const LevelSchema = z.object({
  /**
   * The name of the level.
   */
  levelName: z.string(),
  /**
   * The number (ID) of the level.
   */
  levelNumber: z.number(),
  /**
   * The pack ID of the level. An ID of 1 indicates not part of any pack.
   */
  levelPackNumber: z.number(),
  /**
   * The theme ID of the level, which determines the visual style of the level. The default theme ID is 0.
   */
  levelTheme: z.number(),
  /**
   * The pattern (floor pattern) ID of the level.
   */
  levelPattern: z.number(),
  /**
   * The camera angle of the level.
   */
  levelCamAngle: z.number(),
  /**
   * The mechanics that make up the level.
   */
  levelMechanics: z.array(MechanicSchema),
});
export type Level = z.infer<typeof LevelSchema>;
